import React, { useId, useState } from "react";
import c from "./styles.module.scss";
import Container from "../container";
import { mainText } from "./constants";
import TextBlock from "../textBlock";

const AdditionalText = () => {
  const [expanded, setExpanded] = useState(false);
  const textId = useId();

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <section className={c.additional}>
      <Container>
        <div id={textId} className={`${c.textWrapper} ${expanded ? c.expanded : ""}`}>
          <TextBlock html={mainText} />
          {!expanded && <div className={c.fadeOut}></div>}
        </div>
        <button
          type="button"
          onClick={toggleExpand}
          className={c.readMore}
          aria-expanded={expanded}
          aria-controls={textId}
        >
          {!expanded ? "Читать еще" : "Скрыть"}
        </button>
      </Container>
    </section>
  );
};

export default AdditionalText;
